/** sessionStorage, so it survives the Cognito logout round trip in the same tab. */
const STORAGE_KEY = "bic_session_end_reason";

export const SESSION_END_REASON = {
  TOKEN_REJECTED: "tokenRejected",
} as const;

export type SessionEndReason =
  (typeof SESSION_END_REASON)[keyof typeof SESSION_END_REASON];

const isSessionEndReason = (value: string): value is SessionEndReason =>
  (Object.values(SESSION_END_REASON) as string[]).includes(value);

export const saveSessionEndReason = (reason: SessionEndReason): void => {
  sessionStorage.setItem(STORAGE_KEY, reason);
};

export const loadSessionEndReason = (): SessionEndReason | null => {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  return raw != null && isSessionEndReason(raw) ? raw : null;
};

export const clearSessionEndReason = (): void => {
  sessionStorage.removeItem(STORAGE_KEY);
};
